import { ChangeEvent, ClipboardEvent } from 'react';

import {
    InputDecorator,
    Props as InputWrapperProps,
} from 'components/layout/forms/InputWrapper/types';

export interface Props extends InputWrapperProps {
    className?: string;
    name: string;
    type?: string;
    placeholder?: string;
    value?: string | number;
    onChange: (event: ChangeEvent<HTMLTextAreaElement> | ClipboardEvent<HTMLTextAreaElement>) => any;
    style?: TextareaStyles;
    styles?: object;
    error?: string;
    disabled?: boolean;
    decoratorLeft?: InputDecorator;
    decoratorRight?: InputDecorator;
}

export enum TextareaStyles {
    Primary = 'primary',
}
